import { DEFAULT_PORTAL_URL_SUBDIRECTORY } from "@edl-development/edl-common";
import { UIRouter } from "@uirouter/angular";

const LEGACY_PATHS: string[] = [
    'administrationmanagement',
    'reporting-management',
    'groups',
    'volunteerAreas',
    'users',
    'questionnaires',
    'requests',
    'my-compliance-items',
    'messages',
    'supervision-management'
];

const BASE_AUTHENTICATED_PATH = `/p/${DEFAULT_PORTAL_URL_SUBDIRECTORY}`;


export function redirectLegacyAuthenticatedPaths(router: UIRouter) {
    // Redirect root to default portal
    router.urlService.rules.when(new RegExp("^/$"), `${BASE_AUTHENTICATED_PATH}/`);

    LEGACY_PATHS.forEach(path => {
        const newPath = `${BASE_AUTHENTICATED_PATH}/${path}/$1`;
        router.urlService.rules.when(new RegExp(`^/${path}/(.*)$`), newPath);
    });

    // handle the old my-compliance-items URLs → my-items
    router.urlService.rules.when(
        new RegExp(`^/p/[^/]+/my-compliance-items/(.*)$`),
        (_match, url) => {
            const existingParams = new URLSearchParams();
            Object.entries(url.search || {}).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach(v => existingParams.append(key, `${v}`));
                    return;
                }

                if (value !== undefined && value !== null) {
                    existingParams.append(key, `${value}`);
                }
            });
            let pageNumber: string | undefined;
            const rewrittenPath = url.path.replace(
                /\/my-compliance-items\/(\d+)(?=\/|$)|\/my-compliance-items\//,
                (_fullMatch, page) => {
                    pageNumber = page;
                    return page ? '/my-items/compliance' : '/my-items/';
                }
            );
            if (pageNumber) {
                existingParams.set('page', pageNumber);
            }

            const query = existingParams.toString();
            const hashSuffix = url.hash ? `#${url.hash}` : '';
            return `${rewrittenPath}${query ? `?${query}` : ''}${hashSuffix}`;
        }
    );

    // handle the old supervision-management URLs → all-users-progress or cpl (for any portal subdirectory)
    router.urlService.rules.when(
        new RegExp(`^/p/[^/]+/supervision-management/(.*)$`),
        (_match, url) => {
            if (url.path.includes('/supervision-management/user-compliance')) {
                return url.path.replace('/supervision-management/', '/all-users-progress/');
            }

            if (url.path.includes('/supervision-management/compliance-items')) {
                return url.path.replace('/supervision-management/compliance-items', '/compliance-items');
            }

            return url.path.replace('/supervision-management/', '/compliance-items/');
        }
    );
}
